export default __webpack_public_path__ + "static/media/glaxowellcome.e10728c7.svg";